import { AccountContext } from 'components/AccountContext';
import { api } from 'api/api';

const { createContext, useState, useEffect, useContext } = require('react');
export const SearchContext = createContext();

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const UserContext = ({ children }) => {
  const [allMedicos, setAllMedicos] = useState([]);
  const [medicos, setMedicos] = useState([]);
  const [avaliacoes_atualizadas, setAvaliacoesAtualizadas] = useState([]);
  const [loadingMedicos, setLoadingMedicos] = useState(true);
  const [searchContext, setSearchContext] = useState('all'); // all or search
  const [lastSearch, setLastSearch] = useState('');
  const [professionList, setProfessionList] = useState([]);
  const [profession, setProfession] = useState('Todos');
  const { user, setUser } = useContext(AccountContext);
  const pageDefault = 1;
  const limitDefault = 10;
  const typeList = children?.props?.typeList;
  const sexo = children?.props?.sexo;

  const fetchProfessions = async () => {
    const response = await api(`${ENDPOINT}/schedule/getProfessions`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    const fetchData = await response.json();
    const uniqueProfessions = [...new Set(fetchData)];
    uniqueProfessions.unshift({ nome: 'Todos', profissoes_id: 0 });
    setProfessionList(uniqueProfessions);
  };

  useEffect(() => {
    fetchProfessions();
  }, [user]);

  async function fetchData(url) {
    try {
      let response = await api(url, {
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
      });
      let data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  async function getCoords() {
    try {
      return `&lat=${user.coords.latitudeAtual}&lng=${user.coords.longitudeAtual}`;
    } catch (error) {
      if (
        user.coordenadas_cidade &&
        user.coordenadas_cidade.latitude !== null &&
        user.coordenadas_cidade.latitude !== 'null' &&
        user.coordenadas_cidade.latitude !== undefined &&
        user.coordenadas_cidade.latitude !== 'undefined'
      ) {
        return `&lat=${user.coordenadas_cidade.latitude}&lng=${user.coordenadas_cidade.longitude}`;
      } else {
        return `&city=${user.cidade ? user.cidade : 'FORTALEZA'}`;
      }
    }
  }

  async function fetchAvaliacoes(medicos) {
    if (!medicos) {
      return [];
    }
    const medicos_id = medicos ? medicos.map((medico) => medico.dados.medico_id) : [];

    const response = await api(`${ENDPOINT}/schedule/getAvaliacoesMedicos`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ medicos_id }),
    });
    await response.json().then(async function (postsData) {
      if (!postsData) {
        return [];
      }
      console.log("fetchAvaliacoes ", postsData)
      setAvaliacoesAtualizadas(postsData);
    });
  }

  async function fetchSchedules(page, limit) {
    const sexo = user?.loggedIn ? (user.sexo === 'M' || user.sexo === 'm' ? 'M' : user.sexo === 'F' || user.sexo === 'f' ? 'F' : '') : null;
    let urlPart = await getCoords();
    setLoadingMedicos(true);
    let url = `${ENDPOINT}/schedule/searchMedicos?page=${page}&limit=${limit}${urlPart}&profession=${profession}&typeList=${typeList}&sexo=${sexo}`;
    console.log("fetchSchedules ", url);
    let data = await fetchData(url);
    console.log("data ", data);
    setAllMedicos(data);
    setMedicos(data);
    setSearchContext('all');
    setLoadingMedicos(false);
    await fetchAvaliacoes(data);
  }

  async function fetchSearch(text, page, limit, sexo) {
    let urlPart = await getCoords();
    setLoadingMedicos(true);
    if (!text || text === '') {
      setMedicos(allMedicos);
      setSearchContext('all');
    } else {
      let url = `${ENDPOINT}/schedule/searchMedicos?text=${text}&page=${page}&limit=${limit}${urlPart}&typeList=${typeList}&sexo=${sexo}`;
      let data = await fetchData(url);
      setMedicos(data);
      setLastSearch(text);
      setSearchContext('search');
    }
    setLoadingMedicos(false);
  }

  useEffect(() => {
    fetchSchedules(pageDefault, limitDefault);
  }, [user, profession]);

  return (
    <SearchContext.Provider
      value={{
        allMedicos,
        medicos,
        setMedicos,
        fetchSchedules,
        fetchSearch,
        fetchData,
        loadingMedicos,
        setLoadingMedicos,
        searchContext,
        setSearchContext,
        lastSearch,
        profession,
        professionList,
        setProfession,
        setAvaliacoesAtualizadas,
        avaliacoes_atualizadas,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export default UserContext;
